export const color = {
  black: '#000000',
  lightBlack: '#2a2a2a',
  white: '#ffffff',

  grey: '#c5c5c5',
  lightgrey: '#cecece',
  darkgrey: '#a7a7a7',
  darkerGrey: '#333333',
  lightGrey: '#f2f2f2',

  warning: '#9a2842',
  sale: '#9a2842',

  primary: '#779283',
  secondary: '#a1b3c1',
  success: '#779283',
  primaryDark: '#4d7560',

  blackTransparent: 'rgba(0,0,0,.185)'
};

export const size = {
  small: 320,
  medium: 640,
  large: 800,
  xLarge: 960,
  xXLarge: 1180,
  footerBreakPoint: 850,
  articleSideMenuBreakPoint: 1200,
  articleSideMenuWideBreakPoint: 1600
};

export const breakpoint = {
  medium: 640,
  extraMedium: 640 + (1024 - 640) / 2,
  large: 1024,
  extraLarge: 1200
};

export const animation = {
  transitionTime: '.25s',
  easing: 'ease-out'
};

export const responsiveListPadding = {
  rlpSmall: '4px',
  rlpMedium: '8px',
  rlpLarge: '10px',
  rlpXLarge: '14px'
};

export const header = {
  // values in pixels
  logoAreaDesktopHeight: 110,
  logoAreaMobileHeight: 84,
  menuBarDesktopHeight: 48,
  menuBarMobileHeight: 44
};



// WEBPACK FOOTER //
// ./src/styles/helpers/variables.js